import { isNullOrUndefOrEmpty } from "utils";

/**
 * Ensures that the return value is always an object.
 * @template T
 * @param {T | null | undefined} value input object to check
 * @returns {Partial<T>} the `value` if it's a non-null object, otherwise an empty object
 */
const toObject = (value) => {
  return typeof value !== "object" || isNullOrUndefOrEmpty(value) ? {} : value;
};

export default toObject;
